import React from 'react';

import SettingsForm from '../ui-kit/SettingsForm';

const viewTypeOptions = () =>
  ['dayGridMonth', 'timeGridWeek', 'timeGridDay', 'listWeek'].map(p => ({
    value: p,
    name: I18n.t(`dashboards.widget_archetypes.personal_calendar.view_types.${p}`)
  }));

const Settings = ({ widgetSettings, updateWidgetSettingsField }) => (
  <SettingsForm
    withAutoScroll={true}
    widgetSettings={widgetSettings}
    updateWidgetSettingsField={updateWidgetSettingsField}
    withAutoResizeHeight={true}
  >
    <SettingsForm.Section>
      <SettingsForm.Section.Header>{I18n.t('display')}</SettingsForm.Section.Header>
      <SettingsForm.Section.Content>
        <SettingsForm.RadioButtonGroup
          fieldName={'view_type'}
          labelColWidth={7}
          options={viewTypeOptions()}
          label={I18n.t('attributes.time_unit')}
        />
      </SettingsForm.Section.Content>
    </SettingsForm.Section>
  </SettingsForm>
);
export default Settings;
